import * as React from 'react'
import styled from 'styled-components'
import { DatItem } from './DatItem'
import { DatInput } from './DatInput'
import { DatLabelText } from './DatLabelText'

type Props = {
  onChange?: (value: File) => void
  label: React.ReactNode
  disabled?: boolean
}

const DatItemFile = styled(DatItem)`
  --dat-accent: rgba(148, 163, 184, 0.42);
`

const InputWrapper = styled.div`
  position: relative;
  flex: 1 1 62%;
  min-width: 0;
  overflow: hidden;
  display: inline-block;

  @media (max-width: 520px) {
    flex-basis: 100%;
  }
`

const Button = styled(DatInput)`
  display: block;
  text-align: left;
  color: rgba(226, 232, 240, 0.92);
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`

const File = styled.input`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  font-size: 100px;
  opacity: 0;
  cursor: pointer;
`

export const DatFile = (props: Props) => (
  <DatItemFile>
    <DatLabelText>{props.label}</DatLabelText>

    <InputWrapper>
      <Button type="button" value="Choose `.mdl`" readOnly />

      <File
        type="file"
        accept=".mdl"
        onChange={event => {
          if (typeof props.onChange === 'function') {
            const files: File[] = Array.from(event.target.files || [])

            if (files.length) {
              props.onChange(files[0])
            }
          }
        }}
        disabled={props.disabled}
      />
    </InputWrapper>
  </DatItemFile>
)
